<h1 mat-dialog-title>{{ title }}?</h1>
<mat-dialog-actions align="end">
  <button class="mat-button" (click)="close()">Cancel</button>
  <button style="background-color: #00b188" class="mat-raised-button" (click)="save()">Confirm</button>
</mat-dialog-actions>
